import log from "./log";

class urlPrefetch {
	constructor() {
		this.detectar = this.detectar.bind(this);
		this.detectarSearch = this.detectarSearch.bind(this);
	}
	detectar() {
		$("a").hoverIntent({ over: this.fetchUrl, interval: 50 });
	}
	detectarSearch() {
		log(__filename, "running detectarSearch", "log", false);
		$(".Main-search-result-list").find("a").hoverIntent({ over: this.fetchUrl, interval: 50 });
	}
	unbindSearch() { // eslint-disable-line class-methods-use-this
		log(__filename, "running unbindSearch", "log", false);
		$(".Main-search-result-list").find("a").unbind();
	}
	fetchUrl(url) {
		if (typeof url !== "string") {
			url = $(this).attr("href");
		}
		log(__filename, url, "log", false);


		if ((url.includes(document.domain) && url.includes("https://")) || !url.includes("http")) {
			let flag = true;
			$.each($("head").find(`[rel="prerender prefetch"]`), (index, val) => {
				if ($(val).attr("href") === url) {
					flag = false;
				}
			});
			if (flag) {
				log(__filename, "running fetchUrl", "log", false);
				$("head").append(`<link rel="prerender prefetch" href="${url}">`);
			}
		}
	}
}

export default urlPrefetch;
